export default {"src":"/_next/static/media/structured.18f33c94.svg","height":160,"width":160};